// RouteBridge.jsx
import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function RouteBridge() {
  const location = useLocation();
  const navType = useNavigationType(); // POP, PUSH, REPLACE

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('app:route-changed', {
        detail: {
          pathname: location.pathname,
          search: location.search,
          hash: location.hash,
          state: location.state,
          key: location.key,
          navType,
        },
      })
    );
    // include location.key so same-path navigations still trigger
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.pathname, location.search, location.hash, navType]);

  return null;
}